import {
	FETCH_ACEALERTS_SUCCESS,
	SELECT_ACEALERT,
	ACEALERT
} from "./actions";

const initialState = {
	currently_loading_acealerts: false,
	acealerts_in_current_page: [],
	current_page: 0,
	total_acealerts: 0,
	total_pages: 0,
	new_dando_error: null,
	new_dando_request: {
		dando_name: null,
		ticker: null,
		risk_assessment_date: null,
		last_alert_date: null,
		notes:null
	},
	selected_dando: {},
	alertType:"AceAlerts"
};


const reducerAceAlerts = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_ACEALERTS_SUCCESS:
			return {
				...state,
				current_page: action.page,
				acealerts_in_current_page: action.data,
				total_pages: action.total_pages
			};
		case SELECT_ACEALERT:
			return {...state, selected_dando: {id: action.id}};
			case ACEALERT:
				return {...state,alertType:action.alertType}
		default:
			return state
	}
};


export default reducerAceAlerts;


// WEBPACK FOOTER //
// ./src/ace/redux/reducers.js